const samplingNumber = () => {
	return document.getElementById('samplingNumberInputField').value;
}
export default samplingNumber;
